/* @hotkey */

/**
 * Hotkey
 * @private
 * @memberof HotKeyService
 */

const modifiers = [
  { id: 'ctrl', name: 'Control key', value: 'ctrl' },
  { id: 'shift', name: 'Shift key', value: 'shift' },
  { id: 'alt', name: 'Alt key', value: 'alt' },
  { id: 'win', name: 'Windows key', value: 'win' }
]

const keys = [
  { id: 'a', name: 'a', value: 'a' },
  { id: 'b', name: 'b', value: 'b' },
  { id: 'c', name: 'c', value: 'c' },
  { id: 'd', name: 'd', value: 'd' },
  { id: 'e', name: 'e', value: 'e' },
  { id: 'f', name: 'f', value: 'f' },
  { id: 'g', name: 'g', value: 'g' },
  { id: 'h', name: 'h', value: 'h' },
  { id: 'i', name: 'i', value: 'i' },
  { id: 'j', name: 'j', value: 'j' },
  { id: 'k', name: 'k', value: 'k' },
  { id: 'l', name: 'l', value: 'l' },
  { id: 'm', name: 'm', value: 'm' },
  { id: 'n', name: 'n', value: 'n' },
  { id: 'o', name: 'o', value: 'o' },
  { id: 'p', name: 'p', value: 'p' },
  { id: 'q', name: 'q', value: 'q' },
  { id: 'r', name: 'r', value: 'r' },
  { id: 's', name: 's', value: 's' },
  { id: 't', name: 't', value: 't' },
  { id: 'u', name: 'u', value: 'u' },
  { id: 'v', name: 'v', value: 'v' },
  { id: 'x', name: 'x', value: 'x' },
  { id: 'y', name: 'y', value: 'y' },
  { id: 'z', name: 'z', value: 'z' },
  { id: ',', name: ',', value: ',' },
  { id: '.', name: '.', value: '.' },
  { id: '-', name: '-', value: '-' },
  { id: '+', name: '+', value: '+' },
  { id: '1', name: '1', value: '1' },
  { id: '2', name: '2', value: '2' },
  { id: '3', name: '3', value: '3' },
  { id: '4', name: '4', value: '4' },
  { id: '5', name: '5', value: '5' },
  { id: '6', name: '6', value: '6' },
  { id: '7', name: '7', value: '7' },
  { id: '8', name: '8', value: '8' },
  { id: '9', name: '9', value: '9' },
  { id: '0', name: '0', value: '0' },
  { id: 'tab', name: 'tab', value: 'tab' },
  { id: 'enter', name: 'enter', value: 'enter' },
  { id: 'escape', name: 'escape', value: 'escape' },
  { id: 'del', name: 'delete', value: 'del' },
  { id: 'back', name: 'backspace', value: 'back' },
  { id: 'up', name: 'up', value: 'up' },
  { id: 'down', name: 'down', value: 'down' },
  { id: 'left', name: 'left', value: 'left' },
  { id: 'right', name: 'right', value: 'right' },
  { id: 'f1', name: 'f1', value: 'f1' },
  { id: 'f2', name: 'f2', value: 'f2' },
  { id: 'f3', name: 'f3', value: 'f3' },
  { id: 'f4', name: 'f4', value: 'f4' },
  { id: 'f5', name: 'f5', value: 'f5' },
  { id: 'f6', name: 'f6', value: 'f6' },
  { id: 'f7', name: 'f7', value: 'f7' },
  { id: 'f8', name: 'f8', value: 'f8' },
  { id: 'f9', name: 'f9', value: 'f9' },
  { id: 'f10', name: 'f10', value: 'f10' },
  { id: 'f11', name: 'f11', value: 'f11' },
  { id: 'f12', name: 'f12', value: 'f12' }
]

const self = {
  keys,
  modifiers
}

/**
 *
 * @module HotkeyService
 * @namespace HotkeyService
 * @version 1.0.0
 */
export default self
